import { Box, DialogContent, IconButton, Paper, Slider, styled, Typography } from '@mui/material';

import { colors } from '../../../../theme';

export const POPUP_WIDTH = 1000;
export const POPUP_HEIGHT = 800;
export const CONTENT_HEIGHT = 500;
export const VIDEO_CONTROLS_HEIGHT = 70;

export const StyledDialogPaper = styled(Paper)({
    backgroundColor: colors.tealishBlue,
    color: colors.white,
    borderRadius: '8px',
    width: POPUP_WIDTH,
    height: POPUP_HEIGHT,
    maxHeight: POPUP_HEIGHT,
    display: 'flex',
    flexDirection: 'column'
});

export const HeaderBox = styled(Box)({
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const HeaderTitle = styled(Typography)({
    color: colors.white
});

export const CounterText = styled(Typography)({
    color: colors.white,
    flexGrow: 1,
    textAlign: 'center'
});

export const CloseButton = styled(IconButton)({
    color: colors.white
});

export const FileInfoBox = styled(Box)({
    paddingLeft: '16px',
    paddingRight: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const FileName = styled(Typography)({
    color: colors.white
});

export const DownloadButton = styled(IconButton)({
    color: colors.white,
    marginRight: '8px'
});

export const StyledDialogContent = styled(DialogContent)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    marginTop: '32px',
    marginBottom: '32px',
    position: 'relative',
    backgroundColor: colors.tealishBlue,
    height: CONTENT_HEIGHT,
    flexGrow: 1
});

export const ImageContainer = styled(Box)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
});

export const StyledImage = styled('img')({
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
});

export const VideoContainer = styled(Box)({
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});

export const VideoWrapper = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: `calc(100% - ${VIDEO_CONTROLS_HEIGHT}px)`,
    position: 'relative',
    overflow: 'hidden'
});

export const StyledVideo = styled('video')({
    width: '100%',
    height: '100%',
    objectFit: 'contain'
});

export const PlayButton = styled(IconButton)({
    position: 'absolute',
    backgroundColor: colors.yellow,
    '&:hover': {
        backgroundColor: colors.lightningYellow
    },
    width: '64px',
    height: '64px'
});

export const PlayIconStyles = {
    fontSize: 36,
    color: colors.tealishBlue
};

export const VideoControlsBox = styled(Box)({
    width: '100%',
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingBottom: '16px',
    paddingTop: '8px',
    backgroundColor: colors.tealishBlue,
    height: `${VIDEO_CONTROLS_HEIGHT}px`,
    boxSizing: 'border-box'
});

export const StyledSlider = styled(Slider)({
    color: colors.yellow,
    height: 4,
    '& .MuiSlider-thumb': {
        display: 'none'
    },
    '& .MuiSlider-rail': {
        opacity: 0.3,
        backgroundColor: colors.dimGray
    },
    '& .MuiSlider-track': {
        border: 'none'
    }
});

export const ControlsContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px'
});

export const PlaybackControls = styled(Box)({
    display: 'flex',
    alignItems: 'center'
});

export const ControlButton = styled(IconButton)({
    color: colors.white
});

export const ControlButtonWithMargin = styled(IconButton)({
    color: colors.white,
    marginLeft: '8px',
    marginRight: '8px'
});

export const TimeText = styled(Typography)({
    color: colors.hitGray
});

export const NoPreviewContainer = styled(Box)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px'
});

export const NoPreviewTitle = styled(Typography)({
    color: colors.white,
    textAlign: 'center'
});

export const NoPreviewText = styled(Typography)({
    color: colors.hitGray,
    textAlign: 'center'
});

export const ButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '32px'
});

export const ActionButton = styled(IconButton)({
    backgroundColor: colors.yellow,
    color: colors.white,
    '&:hover': {
        backgroundColor: colors.orangeyYellow80
    },
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '12px',
    paddingBottom: '12px',
    borderRadius: '40px'
});

export const ButtonText = styled(Typography)({
    paddingLeft: '16px',
    paddingRight: '16px'
});
